export class AssetRequestPayload {
    accuracy: string = '';
    altitude: string = 'null';
    gemsId: string = '';
    heading: string = 'null';
    latitude: string = '38.059353699999996';
    longitude: string = '-85.56200849999999';
    speed: string = 'null';
    timestamp: string = '';
    type: string = 'geolocation';
    vanId: string = 'null';
}


